export const DEFAULT_CONFIG = {
    refreshTime: 30, // Seconds
    requirements: {
        minLevel: 10, // Minimum level for displaying ad
        noPaymentDays: 60 // Ad should be displayed for users who didn't have payment for last XX days
    }
}

export const BigFarm = {
    rules: {
        loginData: {
            and: [
                {
                    isGGSNetwork: [{var: ['networkId']}, [1]]
                },
                {
                    in: [
                        {var: 'instanceId'},
                        [
                            /* live instances */ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
                            11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
                            24, 25, /* test instances */ 251, 252,
                            /* temp servers */ 27, 28, 29
                        ]
                    ]
                },
                {'>=': [{var: 'level'}, 10]},
                {in: [{var: 'websiteId'}, '0']},
                {
                    or: [
                        {'==': [{var: 'lastPaymentDate'}, 0]},
                        {isExpired: [{var: 'lastPaymentDate'}, 60]}
                    ]
                }
            ]
        },
        paymentData: {
            or: [
                {'==': [{var: 'lastPaymentTime'}, 0]},
                {isExpired: [{var: 'lastPaymentTime'}, 60]}
            ]
        }
    },
    adSlotSettings: {
        unitPath: `/21812119314/Banner_BigFarm_160x600`,
        size: [160, 600],
        placeholderSize: {
            width: 170,
            height: `100%`
        }
    }
}

export const Empire = {
    rules: {
        loginData: {
            and: [
                {
                    isGGSNetwork: [{var: ['networkId']}, [1]]
                },
                {
                    in: [
                        {var: 'instanceId'},
                        [
                            /* live instances */ 1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            13,
                            14,
                            15,
                            16,
                            17,
                            18,
                            19,
                            20,
                            21,
                            22,
                            23,
                            24,
                            25,
                            26,
                            27,
                            28,
                            29,
                            32,
                            33,
                            34,
                            35,
                            36,
                            37,
                            38,
                            43,
                            46,
                            /* test instances */ 251,
                            257,
                            258,
                            259,
                            260,
                            264,
                            265,
                            267,
                            268,
                            269,
                            290,
                            /* temp servers */ '42',
                            '45'
                        ]
                    ]
                },
                {'>=': [{var: 'level'}, 10]},
                {in: [{var: 'websiteId'}, '0']},
                {
                    or: [
                        {'==': [{var: 'lastPaymentDate'}, 0]},
                        {isExpired: [{var: 'lastPaymentDate'}, 60]}
                    ]
                }
            ]
        },
        paymentData: {
            or: [{'==': [{var: 'LPD'}, 0]}, {isExpired: [{var: 'LPD'}, 60]}]
        }
    },
    adSlotSettings: {
        unitPath: `/21812119314/Banner_Empire_160x600`,
        size: [160, 600],
        placeholderSize: {
            width: 170,
            height: `100%`
        }
    }
}
